import {
  initializeApp,
  FirebaseApp,
  FirebaseOptions,
} from 'firebase/app';
import {
  getAnalytics,
  Analytics,
  logEvent,
} from 'firebase/analytics';

import type {
  ISecondaryAnalyticsService,
  LogPurchaseEventParamsType,
} from './SecondaryAnalyticsService';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line no-undef
const firebaseConfig = FIREBASE_CONFIG as FirebaseOptions;

class SecondaryAnalyticsService
  implements ISecondaryAnalyticsService
{
  private _app: FirebaseApp | null = null;
  private _analytics: Analytics | null = null;

  init() {
    // May we should move initializeApp into separate service
    this._app = initializeApp(firebaseConfig);
    this._app.automaticDataCollectionEnabled = true;
    this._analytics = getAnalytics(this._app);
  }

  logPurchaseEvent({
    transactionId,
    ...eventParams
  }: LogPurchaseEventParamsType) {
    if (this._analytics) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      logEvent(this._analytics, 'purchase', {
        ...eventParams,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        transaction_id: transactionId,
      });
    }
  }
}

export default new SecondaryAnalyticsService();
